import React, { Component } from "react";
import PackagesDataStore from "../../../../Flux/Stores/PackagesDataStore";
import PlacementDataStore from "../../../../Flux/Stores/PlacementDataStore";
import BookFiltersStore from "../../../../Flux/Stores/BookFiltersStore";
import WorkbookStore from "../../../../Flux/Stores/WorkbookStore";
import { refetchPlacements } from "../../../../Flux/Actions/PlacementActions";
import { addNewPackage, setFilteredPackage, updatePlacementsWithPackages, fetchPlacementConfig } from "../../../../Flux/Actions/PlacementActions";
import NewPackage from "../../../Modals/NewPackage";
import EditPackage from "../../../Modals/EditPackage";
import DuplicatePackage from "../../../Modals/DuplicatePackage";
import DeletePackage from "../../../Modals/DeletePackage";
import FindReplaceModal from "../../../Modals/FindReplaceModal";
import GCMPushModal from "../../../Modals/GCMPushModal";
import SyncTooltip from "../../../../Components/Tooltips/SyncTooltip/SyncTooltip";
import MasterCampaignsStore from "../../../../Flux/Stores/MasterCampaignsStore";
import { fetchOnlyPackages, fetchPackagesPostGCMPush } from "../../../../Flux/Actions/PackagesActions";
import LoadingIcon from "../../../../Components/LoadingSpinner";
import PrismaPackageTypeModal from "../../../Modals/PrismaPackageTypeModal";

import Textbox, { TEXTBOX_SIZE } from "@acadia-ui/textbox";
import Button, { BUTTON_SIZE, BUTTON_DISPLAY } from "@acadia-ui/button";
// import { Toolbar } from "./Toolbar";
import DataNotFound from "../../../Modals/DataNotFound";
import { COLUMNS } from "../../../../Components/ShowHideColumns";
import { fetchEnabledColumns, insertUpdateEnabledColumns } from "../../../../Flux/Actions/WorkbookActions";
import Table from "../../../../Components/Table/Table";
import Modal from "@acadia-ui/modal";
import _ from "lodash";
import { TOOLBAR_EVENT_TYPE, TOOLBAR_MODE, EDIT_BUTTON_LOCATION } from "@acadia-ui/toolbar";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import applyFindReplaceToTable from "../applyFindReplaceToTable";
import FullFiltersSidesheet, { fullFilterAlgorithm } from "../FullFiltersSidesheet";
import { showToast, ToastNotification, TOAST_TYPE } from "@acadia-ui/toast";

class LegacyPackageView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			readOnly: true,
			success: false,
			successMessage: null,
			delete: false,
			draftSelected: false,
			selectedCount: 0,
			selectedRows: [],
			isHidden: true,
			searchValue: "",
			advancedFilter: false,
			displayFilter: false,
			extraColumns: [],
			filterOptions: [],
			displayPrismaStatus: false,
			gcmStatus: false,
			search: "",
			TMEnabled: false,
			isProgrammatic: false,
			prismaAPIEnabled: false
		};
		this.filterChoices = BookFiltersStore.getChoicesState();
		this.parentCampaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();

		this.dataTableApi = React.createRef();
	}

	getPackages = () => {
		const packData = PackagesDataStore.getData();
		let siteOptions = null;
		if (PackagesDataStore.getConfig().PackageData !== undefined) {
			PackagesDataStore.getConfig().PackageData.forEach((option) => {
				if (option.Name === "PlatformSiteID") {
					siteOptions = option.Options;
				}
			});
		}
		if (siteOptions !== null) {
			packData.forEach((pack) => {
				if (pack.PlatformSiteID !== null) {
					let platformName = null;
					siteOptions.forEach((site) => {
						if (pack.PlatformSiteID === site.OptionID) {
							platformName = site.OptionLabel;
						}
					});
					if (platformName !== null) {
						pack.PlatformSiteID = platformName;
					}
				}
			});
		}
		this.setState(
			{
				packagesConfig: PackagesDataStore.getConfig(),
				packagesData: PackagesDataStore.getData(),
				...(this.lockLoading ? {} : { loading: false, isHidden: false })
			},
			() => {
				const queryString = window.location.search;
				const urlParams = new URLSearchParams(queryString);
				const packageTX = urlParams.get("Package");
				const placementTX = urlParams.get("Placement");
				if (packageTX) {
					this.handleCrossTrafficQANavigation("Package", packageTX);
				}
			}
		);
	};

	componentDidMount = () => {
		const packageConfig = PackagesDataStore.getConfig();
		if (packageConfig.length === 0) {
			this.props.getCount(null, "Package");
		} else {
			this.getPackages();
		}

		this.setEnabledColumns();

		PackagesDataStore.on("packages_success", this.updatePlacementConfig);
		PackagesDataStore.on("delete_success_placement", this.deletePackageSuccess);
		PackagesDataStore.on("delete_success_no_placement", this.deletePackageSuccess);
		PackagesDataStore.on("duplicate_packages_success", this.duplicatePlacementsSuccess);
		PackagesDataStore.on("packages_loaded", this.getPackages);
		PackagesDataStore.on("edit_success", () => this.updatePlacementConfig(false));
		PackagesDataStore.on("edit_success_placement_fail", () => this.updatePlacementConfig(false));
		PackagesDataStore.on("packages_pushed_to_GCM", this.postGCMPushFetchPackages);
		PackagesDataStore.on("post_gcm_packages_fetched", this.gridChanged);
		WorkbookStore.on("enabled_columns_fetched", this.setEnabledColumns);
		PackagesDataStore.on("packages_lock_unlock_success", this.gridChanged);
		PlacementDataStore.on("placement_created", () => {
			this.props.updateCounts("Placement");
		});
		PlacementDataStore.on("placement_failed", () => {
			this.props.updateCounts("Placement");
		});
	};

	componentWillUnmount() {
		PackagesDataStore.removeListener("packages_success", this.updatePlacementConfig);
		PackagesDataStore.removeListener("delete_success_placement", this.deletePackageSuccess);
		PackagesDataStore.removeListener("delete_success_no_placement", this.deletePackageSuccess);
		PackagesDataStore.removeListener("duplicate_packages_success", this.duplicatePlacementsSuccess);
		PackagesDataStore.removeListener("packages_loaded", this.getPackages);
		PackagesDataStore.removeListener("edit_success", () => this.updatePlacementConfig(false));
		PackagesDataStore.removeListener("edit_success_placement_fail", () => this.updatePlacementConfig(false));
		PackagesDataStore.removeListener("packages_pushed_to_GCM", this.postGCMPushFetchPackages);
		PackagesDataStore.removeListener("post_gcm_packages_fetched", this.gridChanged);
		WorkbookStore.removeListener("enabled_columns_fetched", this.setEnabledColumns);
		PackagesDataStore.removeListener("packages_lock_unlock_success", this.gridChanged);
		PlacementDataStore.removeListener("placement_created", () => {
			this.props.updateCounts("Placement");
		});
		PlacementDataStore.removeListener("placement_failed", () => {
			this.props.updateCounts("Placement");
		});
	}

	componentDidUpdate = (prevProps, prevState) => {
		if (!_.isEqual(prevState.extraColumns, this.state.extraColumns)) {
			// force rerender of table
			this.setState({ isHidden: true }, () => {
				this.setState({ isHidden: false });
			});
		}
	};

	updateGridAndReapplyFilter = () => {
		const data = PackagesDataStore.getData();
		let siteOptions = null;
		PackagesDataStore.getConfig().PackageData.forEach((option) => {
			if (option.Name === "PlatformSiteID") {
				siteOptions = option.Options;
			}
		});
		if (siteOptions !== null) {
			data.forEach((pack) => {
				if (pack.PlatformSiteID !== null) {
					let platformName = null;
					siteOptions.forEach((site) => {
						if (pack.PlatformSiteID === site.OptionID) {
							platformName = site.OptionLabel;
						}
					});
					if (platformName !== null) {
						pack.PlatformSiteID = platformName;
					}
				}
			});
		}
		this.setState({ packagesData: PackagesDataStore.getData(), loading: false }, () => {
			this.props.updateMetaData();
			if (this.state.advancedFilter === true || this.state.searchValue !== "") {
				let filteredData = this.state.packagesData;
				if (this.state.searchValue !== "") {
					filteredData = this.returnSearchedValues(this.state.searchValue);
				}
				if (this.state.advancedFilter === true) {
					const statusAPINames = ["Prisma Status", "DV360 Status", "TM Status"];
					const filteredValues = [];

					filteredData.forEach((row) => {
						let nonMatchingValue = false;
						this.state.filterOptions
							.filter((option) => {
								return option.dataKey !== null;
							})
							.forEach((option) => {
								if (nonMatchingValue !== true) {
									if (!statusAPINames.includes(option.dataKey.Label)) {
										if (option.dataKey.DataType === "Select") {
											if (!row[option.dataKey.Name] || row[option.dataKey.Name] !== option.dataValue.OptionLabel) {
												nonMatchingValue = true;
											}
										} else if (row[option.dataKey.Name] && row[option.dataKey.Name] !== "") {
											try {
												const filterDate = new Date(option.dataValue);
												const rowDate = new Date(row[option.dataKey.Name]);
												if (option.dataKey.Name === "StartDate") {
													if (filterDate > rowDate) {
														nonMatchingValue = true;
													}
												} else if (option.dataKey.Name === "EndDate") {
													if (filterDate < rowDate) {
														nonMatchingValue = true;
													}
												}
											} catch {
												console.log("error comparing dates");
											}
										} else {
											nonMatchingValue = true;
										}
									} else {
										if (option.dataKey.Label === "Prisma Status" || option.dataKey.Label === "DV360 Status") {
											if (!row.ExternalSystemStatusID || row.ExternalSystemStatusID !== option.dataValue.value) {
												nonMatchingValue = true;
											}
										}
										if (option.dataKey.Label === "TM Status") {
											// Consider it a draft if the TraffickingPlacementStatusID is an empty string
											const emptyStringDraftMatch = row.TraffickingPlacementStatusID === "" && option.dataValue.value === "1";
											if (row.TraffickingPlacementStatusID !== option.dataValue.value && !emptyStringDraftMatch) {
												nonMatchingValue = true;
											}
										}
									}
								}
							});
						if (nonMatchingValue === false) {
							filteredValues.push(row);
						}
					});
					this.setState({
						packagesData: filteredValues
					});
				} else {
					this.setState({
						packagesData: filteredData
					});
				}
			}
		});
	};

	handleCrossTrafficQANavigation = (type, taxonomyString) => {
		setTimeout(() => {
			this.dataTableApi?.current?.toolbarApi?.current?.setSearchValue(taxonomyString);
		}, 1);
		const filteredData = this.returnSearchedValues(taxonomyString);
		if (filteredData.length !== 0) {
			this.setState({
				packagesData: filteredData,
				success: false,
				successMessage: null,
				advancedFilter: false
			});
		}
		setTimeout(() => {
			window.history.replaceState({}, document.title, "/Workbook");
		}, 1000);
	};

	checkIfPrismaAPIEnabled = (campaignMetaData) => {
		const statuses = BookFiltersStore.getSyncStatuses();
		if (campaignMetaData && statuses) {
			const { SyncStatus } = statuses.find(({ MasterPlatformID }) => MasterPlatformID == 5);
			const validStatusIDs = [3, 6];
			let platformPKExists = false;
			if (campaignMetaData?.PlatformCampaignPK) {
				try {
					platformPKExists = JSON.parse(campaignMetaData.PlatformCampaignPK).some((platform) => {
						return platform.MasterPlatformID === 5 && platform.PlatformPK;
					});
				} catch {
					console.log("PlatformCampaignPK is not in JSON format");
				}
			}
			return SyncStatus && validStatusIDs.includes(campaignMetaData.ExternalSystemStatusID) && platformPKExists;
		}
		return false;
	};

	setEnabledColumns = () => {
		const prismaAPIEnabled = this.checkIfPrismaAPIEnabled(this.props?.campaignMetaData);
		const syncStatus = BookFiltersStore?.getSyncStatuses()?.find(({ MasterPlatformID }) => MasterPlatformID == this.props?.campaignMetaData?.PlatformID)?.SyncStatus;
		const gcmStatus = BookFiltersStore?.getSyncStatuses()?.find(({ MasterPlatformID }) => MasterPlatformID == 1)?.SyncStatus;
		const clientTMEnabled = WorkbookStore.getIsTrafficEnabled();
		const externalStatus = this.props?.campaignMetaData?.ExternalSystemStatusID;
		const hidePrismaColumns = syncStatus && externalStatus !== 1 ? false : Boolean(syncStatus && externalStatus == 1);
		const enabledColumns = syncStatus
			? COLUMNS.PRISMA.map(({ id, name }) => ({
					id,
					name,
					selected: !hidePrismaColumns
				}))
			: [];
		if (gcmStatus && this.props?.campaignMetaData?.PlatformID == 1) {
			enabledColumns.push(...COLUMNS.GOOGLE_CAMPAIGN_MANAGER);
		}
		const isGCM = this.props.campaignMetaData.PlatformName === "Google Campaign Manager";
		// show google placement ID for GCM platform aswell
		if (isGCM && gcmStatus) {
			enabledColumns.push(COLUMNS.GOOGLE_PLACEMENT_ID);
		}

		enabledColumns.push(COLUMNS.IsDraft);

		const auditLevel = this.props.auditLevelData.find(({ AuditLevelName }) => AuditLevelName == "Package")?.AuditLevelID;
		const Preferences = WorkbookStore.getEnabledColumns()?.find(({ HierarchyLevelID }) => HierarchyLevelID == auditLevel)?.Preferences;
		const parsedPreferences = Preferences ? JSON.parse(Preferences) : null;

		let newEnabledColumns;
		if (parsedPreferences && parsedPreferences instanceof Object) {
			newEnabledColumns = enabledColumns.map(({ id, name, selected }) => ({
				id,
				name,
				selected: parsedPreferences[id] ?? selected
			}));
		} else {
			newEnabledColumns = enabledColumns;
		}
		this.setState({ extraColumns: newEnabledColumns, displayPrismaStatus: syncStatus, gcmStatus, TMEnabled: clientTMEnabled, prismaAPIEnabled });
	};

	updatePlacementConfig = (gridUpdated = true) => {
		if (gridUpdated) {
			this.gridChanged();
		} else {
			this.props.updateMetaData();
		}
	};

	navigateAfterCreation = () => {
		if (PackagesDataStore.getNavigate()) {
			const childData = PackagesDataStore.getConfig().ChildData;
			const tabs = document.querySelectorAll('[role="tab"]');
			if (tabs.length > 0) {
				tabs.forEach((tab) => {
					if (tab.innerHTML.replace(/ *\([^)]*\) */g, "").replace(/\s/g, "") === childData.ChildAuditLevelName) {
						tab.click();
					}
				});
			}
		}
	};

	duplicatePlacementsSuccess = async () => {
		await this.props.updateCounts();
		// this.updatePlacementConfig();
	};

	deletePackageSuccess = () => {
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Package deleted successfully." timed={5000} />);
		this.gridChanged();
	};

	gridChanged = () => {
		const packData = PackagesDataStore.getData();
		let siteOptions = null;
		PackagesDataStore.getConfig().PackageData.forEach((option) => {
			if (option.Name === "PlatformSiteID") {
				siteOptions = option.Options;
			}
		});
		if (siteOptions !== null) {
			packData.forEach((pack) => {
				if (pack.PlatformSiteID !== null) {
					let platformName = null;
					siteOptions.forEach((site) => {
						if (pack.PlatformSiteID === site.OptionID) {
							platformName = site.OptionLabel;
						}
					});
					if (platformName !== null) {
						pack.PlatformSiteID = platformName;
					}
				}
			});
		}

		let preparredData;

		if (Object.keys(this.state.filterOptions ?? {})?.length > 0) {
			this?.dataTableApi?.current?.dataProvider?.update?.(packData);
			preparredData = fullFilterAlgorithm({
				handleFilter: () => {},
				config: PackagesDataStore.getConfig(),
				data: PackagesDataStore.getData(),
				dataTableApi: this.dataTableApi,
				filterOptions: this.state.filterOptions
			});
		} else {
			preparredData = PackagesDataStore.getData();
		}

		this.setState({ packagesData: preparredData, loading: false, selectedRows: [] }, async () => {
			await this.props.updateMetaData();
		});
	};

	navigateToChild = () => {
		if (PackagesDataStore.getNavigate()) {
			window.setTimeout(() => {
				const childData = PackagesDataStore.getConfig().ChildData;
				const tabs = document.querySelectorAll('[role="tab"]');
				if (tabs.length > 0) {
					addNewPackage(PackagesDataStore.getDefaultValue());
					tabs.forEach((tab) => {
						if (tab.innerHTML.replace(/ *\([^)]*\) */g, "") === childData.ChildAuditLevelName) {
							tab.click();
							// document.querySelectorAll('#Placement button')[0].click();
						}
					});
				}
			}, 500);
		}
	};

	openModal = () => {
		this.newPackageModal.triggerOpenClose();
	};

	formatDate = (date) => {
		const d = new Date(date);
		let month = String(d.getMonth() + 1);
		let day = String(d.getDate());
		const year = d.getFullYear();

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;

		return [year, month, day].join("/");
	};

	onMouseOver = (e, domEl, tooltipText) => {
		const dimensions = document.querySelector(`#${domEl}`).getBoundingClientRect();
		SyncTooltip.updateTaxonomyString(e, tooltipText, dimensions, "workbook_packages_sync_taxonomy");
	};

	onMouseOut = (e) => {
		SyncTooltip.closeOpenTaxonomyString(e);
	};

	returnSyncIcon = (item) => {
		if (this.props.campaignMetaData && this.props.campaignMetaData.SyncIcon === "True") {
			const domEl = `id--syncPackage--${item.PackageID}`;
			if (item.PlatformPackagePK === null || (item.PlatformPackagePK !== null && item.ExternalSystemStatusID === "2")) {
				let tooltipText = "Package Sync Error";
				if (item.ExternalSystemResponse !== null && item.ExternalSystemResponse !== "") {
					tooltipText = item.ExternalSystemResponse;
				}
				return (
					<span
						className="syncIssue"
						onMouseOver={(e) => this.onMouseOver(e, domEl, tooltipText)}
						onMouseOut={this.onMouseOut}
						id={domEl}
						style={{ height: "13px", width: "13px", marginTop: "2px" }}
					/>
				);
			}
			if (item.PlatformPackagePK !== null && item.ExternalSystemStatusID === "3") {
				let tooltipText = "Package Successfully Synced";
				if (item.ExternalSystemResponse !== null && item.ExternalSystemResponse !== "") {
					tooltipText = item.ExternalSystemResponse;
				}
				return (
					<span
						className="syncSuccess"
						onMouseOver={(e) => this.onMouseOver(e, domEl, tooltipText)}
						onMouseOut={this.onMouseOut}
						id={domEl}
						style={{ height: "13px", width: "13px", marginTop: "2px" }}
					/>
				);
			}
			if (item.ExternalSystemStatusID === "4") {
				let tooltipText = "Package Sent To Queue";
				if (item.ExternalSystemResponse !== null && item.ExternalSystemResponse !== "") {
					tooltipText = item.ExternalSystemResponse;
				}
				return (
					<span
						className="syncQueue"
						onMouseOver={(e) => this.onMouseOver(e, domEl, tooltipText)}
						onMouseOut={this.onMouseOut}
						id={domEl}
						style={{ height: "13px", width: "13px", marginTop: "2px" }}
					/>
				);
			}
			if (item.ExternalSystemStatusID === "5") {
				let tooltipText = "Package Excluded From Syncing";
				if (item.ExternalSystemResponse !== null && item.ExternalSystemResponse !== "") {
					tooltipText = item.ExternalSystemResponse;
				}
				return (
					<span
						className="syncExclude"
						onMouseOver={(e) => this.onMouseOver(e, domEl, tooltipText)}
						onMouseOut={this.onMouseOut}
						id={domEl}
						style={{ height: "13px", width: "13px", marginTop: "2px" }}
					/>
				);
			}
		} else {
			return null;
		}
	};

	navigateToPlacements = async (selectedPackage, refresh = true) => {
		this.setState({ loading: true, isHidden: true });
		this.lockLoading = true;
		refresh && (await this.props.updateCounts());
		this.duplicatePackageModal?.placementsTabReady?.();
		this.props.navigateToPlacements(selectedPackage);
		this.setState({ loading: false, isHidden: false }, () => {
			this.lockLoading = false;
		});
	};

	unlockSheet = () => {
		this.setState({
			readOnly: !this.state.readOnly,
			success: false,
			successMessage: null,
			delete: false
		});
	};

	lockSheet = () => {
		this.setState({
			readOnly: true,
			success: true,
			successMessage: null,
			delete: false
		});
	};

	numberSelected = (row, chk, selectAll = false) => {
		let newSelectedRows = this.state.selectedRows;
		let draftSelected = false;
		if (!selectAll) {
			if (chk) {
				newSelectedRows.push(row);
				if (row.IsDraft === "True") {
					draftSelected = true;
				}
			} else {
				newSelectedRows = newSelectedRows.filter((selectedRow) => {
					return selectedRow.UniqueID != row.UniqueID;
				});
			}
		} else {
			newSelectedRows = row;
			if (
				row.find((data) => {
					return data.IsDraft === "True";
				})
			) {
				draftSelected = true;
			}
		}
		this.setState({
			selectedRows: newSelectedRows,
			selectedCount: newSelectedRows.length,
			success: false,
			delete: false,
			singleSelected: newSelectedRows.length === 1,
			multipleSelected: newSelectedRows.length > 1,
			draftSelected
		});
	};

	cancelChanges = () => {
		this.setState(
			{
				readOnly: !this.state.readOnly,
				loading: true,
				success: false,
				successMessage: null
			},
			() => {
				const auditLevelArray = [];
				this.props.auditLevelData.forEach((auditLevel) => {
					auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
				});
				const choices = JSON.parse(JSON.stringify(this.filterChoices));
				let auditLevelChoice = null;
				auditLevelArray.forEach((auditLevel) => {
					if (auditLevel.label === "Package") {
						auditLevelChoice = auditLevel;
					}
				});
				if (auditLevelChoice !== null) {
					choices.auditlevel = auditLevelChoice;
					fetchOnlyPackages(choices, this.parentCampaignUniqueID);
					this.gridChanged();
				}
			}
		);
	};

	setSelectedRow = (callback) => {
		const selectedLine = this.state.selectedRows[0];
		const dataArr = {};
		Object.keys(selectedLine).forEach((key) => {
			if ((key === "EndDate" || key === "StartDate") && selectedLine[key] !== "") {
				dataArr[key] = this.formatDate(selectedLine[key]);
			} else if (key === "Cost") {
				dataArr[key] = selectedLine[key].replace(/[^\d.-]/g, "");
			} else if (key === "PackageName_Friendly") {
				if (typeof selectedLine[key] === "string") {
					dataArr[key] = selectedLine[key];
				} else if (typeof selectedLine[key] === "object") {
					if (document.getElementById(selectedLine.PackageID)) {
						dataArr[key] = document.getElementById(selectedLine.PackageID).getAttribute("name");
					}
				}
			} else {
				dataArr[key] = selectedLine[key];
			}
		});
		this.setState({ selectedRow: dataArr }, () => {
			callback?.();
		});
	};

	refetchPackages = () => {
		const auditLevelArray = [];
		this.props.auditLevelData.forEach((auditLevel) => {
			auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
		});
		const choices = JSON.parse(JSON.stringify(this.filterChoices));
		let auditLevelChoice = null;
		auditLevelArray.forEach((auditLevel) => {
			if (auditLevel.label === "Package") {
				auditLevelChoice = auditLevel;
			}
		});
		if (auditLevelChoice !== null) {
			choices.auditlevel = auditLevelChoice;
			fetchOnlyPackages(choices, this.parentCampaignUniqueID).then(() => {
				this.gridChanged();
				this.setState({ readOnly: true, searchValue: "", advancedFilter: false, displayFilter: false });
				const auditLevelArray = [];
				this.props.auditLevelData.forEach((auditLevel) => {
					auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
				});
				const choices = JSON.parse(JSON.stringify(this.filterChoices));
				let auditLevelChoice = null;
				auditLevelArray.forEach((auditLevel) => {
					if (auditLevel.label === "Placement") {
						auditLevelChoice = auditLevel;
					}
				});
				if (auditLevelChoice !== null) {
					this.updatePlacementConfig(false);
					choices.auditlevel = auditLevelChoice;
					const updatePlacements = this.state.packagesData.some((data) => {
						return parseInt(data.ChildCount) > 0;
					});
					if (updatePlacements === true) {
						this.setState({ loading: true }, () => {
							refetchPlacements(choices, this.parentCampaignUniqueID).then(() => {
								this.setState({ loading: false });
							});
						});
					}
				}
			});
		}
	};

	postGCMPushFetchPackages = () => {
		const auditLevelArray = [];
		this.props.auditLevelData.forEach((auditLevel) => {
			auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
		});
		const choices = JSON.parse(JSON.stringify(this.filterChoices));
		let auditLevelChoice = null;
		auditLevelArray.forEach((auditLevel) => {
			if (auditLevel.label === "Package") {
				auditLevelChoice = auditLevel;
			}
		});
		if (auditLevelChoice !== null) {
			choices.auditlevel = auditLevelChoice;
			fetchPackagesPostGCMPush(choices, this.parentCampaignUniqueID);
		}
	};

	returnSearchedValues = (searchTerm) => {
		const searchableFields = [];
		const filteredData = [];
		const configKeys = Object.keys(this.state.packagesConfig);
		configKeys.forEach((bucket) => {
			if (Array.isArray(this.state.packagesConfig[bucket])) {
				this.state.packagesConfig[bucket].forEach((field) => {
					if (field.IsSummarizedHeader === true || field.Name === "PackageName") {
						searchableFields.push(field.Name);
					}
				});
			}
		});
		this.state.packagesData.forEach((data) => {
			let matchFound = false;
			for (const field of searchableFields) {
				if (data[field]) {
					if (data[field].toLowerCase().includes(searchTerm.toLowerCase())) {
						filteredData.push(data);
						matchFound = true;
						break;
					}
				}
			}
			if (matchFound === false && data.PlatformPackagePK) {
				const targetValue = JSON.parse(data.PlatformPackagePK)?.find(({ MasterPlatformID }) => [1, 5].includes(MasterPlatformID));
				if (targetValue?.PlatformPK && targetValue.PlatformPK.toLowerCase().includes(searchTerm.toLowerCase())) {
					filteredData.push(data);
				}
			}
		});
		return filteredData;
	};

	clearSearch = () => {
		this.setState({
			packagesData: PackagesDataStore.getData(),
			searchValue: "",
			success: false,
			successMessage: null,
			advancedFilter: false,
			displayFilter: false
		});
		document.getElementById("searchPackage").value = "";
	};

	updateChildPlacements = (packageID) => {
		const choices = JSON.parse(JSON.stringify(BookFiltersStore.getChoicesState()));
		this.parentCampaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
		let auditLevelChoice = null;
		const auditLevelArray = [];
		this.props.auditLevelData.forEach((auditLevel) => {
			auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
		});
		auditLevelArray.forEach((auditLevel) => {
			if (auditLevel.label === "Placement") {
				auditLevelChoice = auditLevel;
			}
		});
		if (auditLevelChoice !== null) {
			choices.auditlevel = auditLevelChoice;
			this.setState({ loading: true }, () => {
				updatePlacementsWithPackages(choices, this.parentCampaignUniqueID, packageID);
			});
		}
	};

	handleFilter = (filteredData, applyFilter, filterOptions) => {
		if (!document.getElementById("Package_find_replace_modal")?.hasAttribute("open")) {
			if (applyFilter === true) {
				this.setState({
					packagesData: filteredData,
					advancedFilter: true,
					displayFilter: false,
					filterOptions
				});
			} else if (this.state.searchValue !== "") {
				if (filteredData.length !== 0) {
					this.setState({
						packagesData: filteredData,
						advancedFilter: false,
						displayFilter: false,
						filterOptions: []
					});
				} else {
					this.setState({
						packagesData: PackagesDataStore.getData(),
						advancedFilter: false,
						displayFilter: false,
						filterOptions: []
					});
				}
			} else {
				this.setState({
					packagesData: PackagesDataStore.getData(),
					advancedFilter: false,
					displayFilter: false,
					filterOptions: []
				});
			}
		}
	};

	replaceData = (data, toggleEditing = false) => {
		applyFindReplaceToTable({
			data,
			dataTableApi: this.dataTableApi,
			toggleEditing,
			syncData: (updatedData) => {
				this.setState({ packagesData: updatedData });
			}
		});
	};

	handleToolbarEvent = (type, { value }) => {
		// console.log(type, { value });
		switch (type) {
			case TOOLBAR_EVENT_TYPE.TOOLBAR_MODE_CHANGE:
				// this.setState({ readOnly: value !== TOOLBAR_MODE.EDIT });
				break;
			case "settings-sidesheet-saved":
				this.saveShowHideColumns(value);
				break;
			default:
			// noop
		}
	};

	saveShowHideColumns = async (value) => {
		const { columnVisibility } = value;
		const columnVisKeyMap = {
			PlatformStatus: "ExternalSystemStatusID",
			PrismaID: "PlatformPackagePK",
			GooglePlacementID: "GoogleCampaignManagerPK"
		};

		const columns = this.state.extraColumns?.map((column) => ({ ...column, selected: columnVisibility[columnVisKeyMap[column.id]] }));
		const { auditLevelData, campaignMetaData } = this.props;
		const auditLevel = auditLevelData.find(({ AuditLevelName }) => AuditLevelName == "Package")?.AuditLevelID;
		const { ApplicationUserSettingsID } = WorkbookStore.getEnabledColumns()?.find(({ HierarchyLevelID }) => HierarchyLevelID == auditLevel) || {};

		await insertUpdateEnabledColumns({
			ApplicationUserSettingsID,
			CampaignID: campaignMetaData.CampaignUniqueIDCode,
			HierarchyLevelID: auditLevel,
			ColumnHeaders: columns.reduce((acc, { id, selected }) => {
				acc[id] = selected;
				return acc;
			}, {})
		});

		await fetchEnabledColumns(WorkbookStore.getMetaData().CampaignUniqueIDCode);
	};

	onDelete = (handleDelete) => {
		this.setState({ loading: true, selectedRows: [], packagesData: null }, () => {
			Modal.hide("deletePackagesModal");
			// the callback passed here is onSuccess, delays refetching until promise.all resolves
			handleDelete(async () => {
				// this.refetchPackages();
				await this.props.updateCounts("Package");
			});
		});
	};

	handleRowSelection = (selectedRows) => {
		this.setState({
			selectedRows
		});
	};

	render() {
		let childName = "";
		if (this.state.packagesConfig) {
			if (this.state.packagesConfig.ChildData) {
				if (this.state.packagesConfig.ChildData.ChildAuditLevelName) {
					childName = this.state.packagesConfig.ChildData.ChildAuditLevelName;
				}
			}
		}
		// packagesConfig is for Modal
		const { packagesConfig, packagesData, isProgrammatic } = this.state;

		const auditLevelID = this.props.auditLevelData.find(({ AuditLevelName }) => AuditLevelName === "Package")?.AuditLevelID;
		const showSettingsSideSheet = this.props.campaignMetaData.PlatformName == "Mediaocean (OX)/Prisma" && this.state.extraColumns?.length > 0;
		const { SyncStatus } = BookFiltersStore?.getSyncStatuses().find(({ MasterPlatformID }) => MasterPlatformID == 5);
		const isPrisma = this.props.campaignMetaData.PlatformName === "Mediaocean (OX)/Prisma";

		const hasGCMSyncID =
			JSON.parse(this.props.campaignMetaData?.PlatformCampaignPK || "[]")?.find(({ MasterPlatformID }) => MasterPlatformID == 1)?.PlatformPK?.length > 0 || false;
		const draftSelected = this.state.selectedRows.some((row) => row.IsDraft === "True");
		const gcmDisabled = !hasGCMSyncID || this.state.selectedRows.some((row) => row.ExternalSystemStatusID == "3") || draftSelected;
		return (
			<section className="tab__container">
				{this.state.loading && <LoadingIcon />}

				<>
					{packagesData && packagesConfig && (
						<>
							{!this.state.isHidden ? (
								<Table
									ref={this.dataTableApi}
									data={packagesData}
									config={packagesConfig}
									hierarchyLevel="Package"
									metaData={this.props.campaignMetaData}
									placementAPI={this.props.placementAPI}
									JIRAStatus={this.state.TMEnabled}
									syncAPI={this.props.campaignMetaData && this.props.campaignMetaData.SyncIcon === "True"}
									updateSelected={this.handleRowSelection} // Need to eventually incorporate the logic from numberSelected function
									refetchData={this.refetchPackages}
									navigateToChild={(pkg) => this.navigateToPlacements(pkg, false)}
									search={this.state.search}
									onSearch={(searchValue) => {
										this.setState({ search: searchValue });
									}}
									// Package specific props and extra columns
									extraColumns={this.state.extraColumns}
									gcmStatus={this.state.gcmStatus}
									auditLevelID={auditLevelID}
									rowHeight={this.state.rowHeight}
									setRowHeight={(v) => {
										this.setState({ rowHeight: v });
									}}
									actionBarProps={{
										search: (
											<Textbox
												debounceTimeout={500}
												size={TEXTBOX_SIZE.SMALL}
												onClear={(e) => {
													this.dataTableApi?.current?.dataProvider?.search("");
													this.setState({ searchValue: "", packagesData: PackagesDataStore.getData() });
												}}
												value={new URLSearchParams(location.search)?.get?.("taxonomy") || this.state.searchValue || undefined}
											>
												Search
											</Textbox>
										),
										settingsSideSheet: showSettingsSideSheet,
										filtersSideSheet: (
											<FullFiltersSidesheet
												displayPrismaStatusFilter={SyncStatus && isPrisma}
												TMEnabled={this.state.TMEnabled}
												filterOptions={this.state.filterOptions}
												hierarchyLevel="Package"
												ref={this.dataTableApi}
												data={PackagesDataStore.getData()}
												config={packagesConfig}
												handleFilter={this.handleFilter}
											/>
										),
										editButton: (
											<Button
												// this comment exists to prevent eslint from making this unreadable.
												style={{ order: 2 }}
												display={BUTTON_DISPLAY.SECONDARY}
												size={BUTTON_SIZE.SMALL}
												data-tracking-id-alt="open-edit-package-details-modal"
											>
												Edit Details
											</Button>
										),
										showEditMode: EDIT_BUTTON_LOCATION.DEFAULT_MODE_ACTIONS,
										defaultModeActions: [
											<Button
												style={{ order: 1 }}
												size={BUTTON_SIZE.SMALL}
												display={BUTTON_DISPLAY.TEXT}
												key="package-find-replace"
												data-tracking-id-alt="open-package-find-replace-modal"
												onClick={() => {
													this.findReplaceModal.triggerOpenClose();
												}}
											>
												Find and Replace
											</Button>,
											<Button
												style={{ order: 3 }}
												key="add-package"
												size={BUTTON_SIZE.SMALL}
												onClick={() => {
													if (this.props.campaignMetaData?.PlatformID == 5) {
														this.setState({ isProgrammatic: false }, () => {
															Modal.show("package-type-modal");
														});
													} else {
														this.newPackageModal.triggerOpenClose();
													}
												}}
												data-tracking-id-alt="open-add-package-modal"
											>
												Add Package
											</Button>
										],
										actions: [
											<Tooltip key="action-edit" title="Edit Package" position={TOOLTIP_POSITION.BOTTOM_START}>
												<Button
													// this comment exists to prevent eslint from making this unreadable.
													size={BUTTON_SIZE.SMALL}
													display={BUTTON_DISPLAY.ICON_BORDERED}
													icon="icon-pencil"
													onClick={() => this.editPackageModal.triggerOpenClose()}
													data-tracking-id-alt="open-edit-package-modal"
													disabled={this.state.selectedRows?.length > 1}
												>
													Edit Package
												</Button>
											</Tooltip>,
											<Tooltip key="action-clone" title="Clone Package" position={TOOLTIP_POSITION.BOTTOM_START}>
												<Button
													// this comment exists to prevent eslint from making this unreadable.
													size={BUTTON_SIZE.SMALL}
													display={BUTTON_DISPLAY.ICON_BORDERED}
													icon="icon-copy"
													onClick={() => this.duplicatePackageModal.triggerOpenClose()}
													data-tracking-id-alt="open-clone-package-modal"
													disabled={this.state.selectedRows?.length > 1 || draftSelected}
												>
													Clone Package
												</Button>
											</Tooltip>,
											<Tooltip key="action-delete" title="Delete Package" position={TOOLTIP_POSITION.BOTTOM_START}>
												<Button
													size={BUTTON_SIZE.SMALL}
													display={BUTTON_DISPLAY.ICON_BORDERED}
													icon="icon-delete"
													onClick={() => Modal.show("deletePackagesModal")}
													data-tracking-id-alt="open-delete-package-modal"
												>
													Delete Package
												</Button>
											</Tooltip>,
											...(this.state.gcmStatus && this.props?.campaignMetaData?.PlatformID == 1
												? [
														<Tooltip
															key="action-sync"
															title={!hasGCMSyncID ? "Please sync your campaign first" : "Sync"}
															position={TOOLTIP_POSITION.BOTTOM_START}
														>
															<Button
																size={BUTTON_SIZE.SMALL}
																display={BUTTON_DISPLAY.ICON_BORDERED}
																icon="icon-status-syncing"
																onClick={() => Modal.show("GCM_package_modal")}
																disabled={gcmDisabled}
																data-tracking-id-alt="open-sync-package-modal"
															>
																Sync
															</Button>
														</Tooltip>
													]
												: [])
										],
										onToolbarEvent: this.handleToolbarEvent
									}}
								/>
							) : (
								<LoadingIcon />
							)}
						</>
					)}

					<NewPackage
						newPackage={(ref) => {
							this.newPackageModal = ref;
						}}
						config={packagesConfig}
						filters={this.filterChoices}
						childName={childName}
						metaData={this.props.campaignMetaData}
						updateCounts={this.props.updateCounts}
						updateMetaData={this.props.updateMetaData}
						auditLevelID={auditLevelID}
						isProgrammatic={isProgrammatic}
					/>
					<EditPackage
						editPackage={(ref) => {
							this.editPackageModal = ref;
						}}
						config={packagesConfig}
						filters={this.filterChoices}
						packageData={this.state.selectedRows[0]}
						refresh={this.gridChanged}
						metaData={this.props.campaignMetaData}
						updateMetaData={this.props.updateMetaData}
						updateCounts={this.props.updateCounts}
						updatePlacementsWithPackages={this.updateChildPlacements}
						tabNames={this.props.tabNames}
						auditLevelID={auditLevelID}
					/>
					<DuplicatePackage
						duplicatePackage={(ref) => {
							this.duplicatePackageModal = ref;
						}}
						config={packagesConfig}
						filters={this.filterChoices}
						duplicateData={this.state.selectedRows[0]}
						refresh={this.gridChanged}
						metaData={this.props.campaignMetaData}
						updateMetaData={this.props.updateMetaData}
						updateCounts={this.props.updateCounts}
						tabNames={this.props.tabNames}
						getPlacementCount={this.props.getPlacementCount}
						navigate={this.navigateToPlacements}
						auditLevelID={auditLevelID}
						setSelectedPackage={this.props.setSelectedPackage}
					/>
					<DeletePackage
						// this comment exists to prevent eslint from making this unreadable.
						data={this.state.selectedRows}
						config={packagesConfig}
						auditLevelData={this.props.auditLevelData}
						onDelete={this.onDelete}
						prismaAPIEnabled={this.state.prismaAPIEnabled}
						onFailure={() => this.refetchPackages}
					/>
					<FindReplaceModal
						findReplaceModal={(ref) => {
							this.findReplaceModal = ref;
						}}
						type={"Package"}
						hierarchyLevel="Package"
						config={packagesConfig}
						data={packagesData}
						replaceData={this.replaceData}
						tableRef={this.dataTableApi}
					/>
					<GCMPushModal modalId="GCM_package_modal" type={"Package"} data={this.state.selectedRows} />
					<PrismaPackageTypeModal
						modalId="package-type-modal"
						isProgrammatic={isProgrammatic}
						toggleProgramatic={(value) => this.setState({ isProgrammatic: value })}
						handleNext={() => this.newPackageModal.triggerOpenClose()}
					/>
				</>
			</section>
		);
	}
}
export default LegacyPackageView;
